import Gameplay from './Gameplay';

export default Gameplay;
